
import { Suspense } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import About from './components/About';
import TrustedBrands from './components/TrustedBrands';
import Services from './components/Services';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Hero />
          <About />
          <TrustedBrands />
          <Services />
          <Contact />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
}
